import request from '@/utils/request'
import user from '@/service/user'

export default {
  // 统一下单
  createOrder (param) {
    return request.post(`/wx/pay/createOrder`, param)
      .then(res => res)
  },
  // 微信登录
  login (redirectUrl) {
    const code = this.getUrlParam('code')
    if (code) {
      user.getUserInfo(code).then(result => {
        // alert('获取用户信息')
        sessionStorage.setItem('token', result.data.token)
        sessionStorage.setItem('openId', result.data.openId)
        sessionStorage.setItem('nickname', result.data.nickname)
        sessionStorage.setItem('headImgUrl', result.data.headImgUrl)
        window.location.replace(process.env.BASE_API + this.getUrlParam('state'))
        // window.location.reload()
      })
    } else {
      user.login(process.env.BASE_API + process.env.CONTEXT_PATH + 'wx/callback', redirectUrl).then(result => {
        // alert('微信登录')
        window.location.href = result.data
      })
    }
  },
  getUrlParam (name) {
    const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
    const r = window.location.search.substr(1).match(reg)
    if (r != null) return unescape(r[2])
    return ''
  },
  // 微信分享-获取签名
  getSign (url) {
    return request.get(`/wx/getSign?url=${url}`)
      .then(res => res)
  },
  // 微信分享
  share (title, desc, link, imgUrl, raiseFoodId) {
    this.getSign(link).then(result => {
      // eslint-disable-next-line no-undef
      wx.config({
        debug: false,
        appId: result.data.appId,
        timestamp: result.data.timestamp,
        nonceStr: result.data.nonceStr,
        signature: result.data.signature,
        jsApiList: [
          'updateAppMessageShareData',
          'updateTimelineShareData'
        ]
      })
      // eslint-disable-next-line no-undef
      wx.ready(function () {
        // eslint-disable-next-line no-undef
        wx.updateAppMessageShareData({ // 自定义“分享给朋友”及“分享到QQ”按钮的分享内容
          title: title, // 分享标题
          desc: desc, // 分享描述
          link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: imgUrl, // 分享图标
          success: function () {
            // 设置成功
          }
        })
        // eslint-disable-next-line no-undef
        wx.updateTimelineShareData({ // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容
          title: title, // 分享标题
          desc: desc, // 分享描述
          link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: imgUrl, // 分享图标
          success: function () {
            // 设置成功
          }
        })
      })
    })
  },
  // 保存分享记录
  saveShareRecords (raiseFoodId) {
    return request.post(`/share/save`, {'raiseFoodId': raiseFoodId})
      .then(res => res)
  }
}



// WEBPACK FOOTER //
// ./src/service/wx.js